'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var productDiscountsComponent = exports.productDiscountsComponent = {
    template: require('./product-discounts.html'),
    bindings: {
        close: '&',
        context: '<',
        portalContractTypeCode: '<',
        isLoading: '<',
        parentState: '<',
        productDiscounts: '<',
        parentProductType: '<',
        activeDiscounts: '<',
        totalPriceDiscountIds: '<'
    },
    controllerAs: 'vm',
    controller: ["common", "discountTypeNames", function controller(common, discountTypeNames) {
        'ngInject';

        var vm = this;
        vm.getDiscountType = getDiscountType;
        vm.isActiveDiscount = isActiveDiscount;
        vm.isTotalPriceDiscountId = isTotalPriceDiscountId;
        vm.counter = getCounter;

        function getDiscountType(discountType) {
            return discountTypeNames[discountType].clientValue;
        }
        function getCounter() {
            return;
        }
        function isActiveDiscount(productDiscount) {
            var idSearch = vm.activeDiscounts.find(function (activeDiscountId) {
                return productDiscount.discountId === activeDiscountId;
            });
            return idSearch ? 'product-discount is-active' : 'product-discount';
        }

        function isTotalPriceDiscountId(productDiscount) {
            var idSearch = vm.totalPriceDiscountIds.find(function (totalPriceDiscountId) {
                return productDiscount.discountId === totalPriceDiscountId;
            });
            return idSearch ? 'product-discount is-active' : 'product-discount';
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/product/components/product-discounts.js
// module id = 970
// module chunks = 0